import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { CustomDialog } from "components/atoms";
import CustomizeDynamicTable from "components/CustomizeDynamicTable/CustomizeDynamicTable";
import ESign from "components/ESign";
import MainCard from "components/MainCard";
import withRouter from "components/withRouter";
import DocumentAuditLogs from "pages/Audit-Trail/DocumentAuditLogs";
import React, { useEffect, useRef, useState } from "react";
import {
  AuditActionTypeConstant,
  AuditDocumentTypes,
  DepartmentConstants,
  FormatConstants,
  routeConstants,
  TypeConstants,
} from "services/keyConstants";
import { getMasterDoc } from "services/ReduxUtils";
import {
  downloadFormat,
  extractUserDetails,
  filterUserById,
  filterUserByIdAndDesignationId,
  generateAuditObj,
  getAllAuditChanges,
  sendNotification,
  showToast,
} from "services/utils";
import * as url from "./utils/UrlHelper";
import { ApiServices } from "services/apiServices";
import { Download } from "@mui/icons-material";
import { getUserDataByDesignation } from "services/organogramServices";
import { ADD_DATA } from "pages/finishedProductRegister/utils/urlHelper";

const BatchCheckList = (props) => {
  const {
    data,
    isLoading,
    getDataById,
    userData,
    selectedRole,
    onChangeDownloadState,
    AuditActionTypeConstant,
    AuditDocumentTypes,
    type,
  } = props;
  console.log("called 1");
  const submitData = useRef({});
  const { id } = props?.router?.params || {};

  const [rows, setRows] = useState({
    batchDetailsFormRows: data?.batchDetailsFormRows ?? {},
    conclusionFormRows: {},
    sterileNonSterileRows: data?.sterileNonSterileRows ?? [],
    signFormRows: {},
    yieldFormRows: data?.yieldFormRows ?? {},
  });

  const [decisionData, setDecisionData] = useState({ decision: "" });
  const [openEsign, setOpenEsign] = useState(false);
  const [modalType, setModalType] = useState(false);
  let masterDocData = getMasterDoc(
    type === "Sterile"
      ? FormatConstants.PRODUCTION.BACTH_RELEASE_STRELIE
      : FormatConstants.PRODUCTION.BACTH_RELEASE_NON_STRELIE,
  );

  props?.getTitle(masterDocData?.name);
  const submitHandlers = useRef({
    batchDetailsSubmit: null,
    sterileNonSterileSubmit: null,
    yieldFormSubmit: null,
    conclusionFormSubmit: null,
    signFormSubmit: null,
  });

  useEffect(() => {
    if (data?.document) {
      const document = data?.document;
      setRows({
        batchDetailsFormRows: document?.batchDetailsFormRows,
        conclusionFormRows: document?.conclusionFormRows,
        signFormRows: document?.signFormRows,
        sterileNonSterileRows: document?.sterileNonSterileRows,
        yieldFormRows: document?.yieldFormRows,
      });
    } else {
      setRows({
        batchDetailsFormRows: data?.batchDetailsFormRows ?? {},
        conclusionFormRows: {
          conclusion:
            "All release criteria have been verified and found not met; hence, the batch is not approved for release.",
        },
        sterileNonSterileRows: data?.sterileNonSterileRows ?? [],
        signFormRows: {},
        yieldFormRows: data?.yieldFormRows ?? {},
      });
    }
  }, [data]);

  const findColumnsByDefaultName = (tableName) => {
    return (
      data?.formatStructureId?.structuredData?.find(
        (table) =>
          table?.defaultTableName === tableName ||
          table?.tableName === tableName,
      )?.columns ?? []
    );
  };

  const handleMasterSubmit = async (type) => {
    try {
      let allValid = true;
      let allData = {};

      if (submitHandlers.current.batchDetailsSubmit) {
        const batchDetailsSubmit = submitHandlers.current.batchDetailsSubmit();
        if (batchDetailsSubmit === false) {
          allValid = false;
        } else {
          allData.batchDetailsSubmit = batchDetailsSubmit;
        }
      }

      if (submitHandlers.current.signFormSubmit) {
        const signFormSubmit = submitHandlers.current.signFormSubmit();
        if (signFormSubmit === false) {
          allValid = false;
        } else {
          allData.signFormSubmit = signFormSubmit;
        }
      }

      if (submitHandlers.current.sterileNonSterileSubmit) {
        const sterileNonSterileSubmit =
          submitHandlers.current.sterileNonSterileSubmit();
        if (sterileNonSterileSubmit === false) {
          allValid = false;
        } else {
          allData.sterileNonSterileSubmit = sterileNonSterileSubmit;
        }
      }

      if (submitHandlers.current.conclusionFormSubmit) {
        const conclusionFormSubmit =
          submitHandlers.current.conclusionFormSubmit();
        if (conclusionFormSubmit === false) {
          allValid = false;
        } else {
          const isVerified = allData.sterileNonSterileSubmit?.rows?.every(
            (r) => r?.documentStatus === "Verified",
          );
          if (isVerified) {
            allData.conclusionFormSubmit = {
              conclusion:
                "All release criteria have been verified and met. The batch is approved for release.",
            };
          } else {
            allData.conclusionFormSubmit = {
              conclusion:
                "All release criteria have been verified and found not met; hence, the batch is not approved for release.",
            };
          }
        }
      }

      if (submitHandlers.current.yieldFormSubmit) {
        const yieldFormSubmit = submitHandlers.current.yieldFormSubmit();
        if (yieldFormSubmit === false) {
          allValid = false;
        } else {
          allData.yieldFormSubmit = yieldFormSubmit;
        }
      }
      if (allValid) {
        submitData.current = { ...allData, type: type };
        setOpenEsign(true);
      } else {
        console.error("Some tables have validation errors");
      }
    } catch (error) {
      console.error("Error in master submit:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setDecisionData((pre) => ({ ...pre, [name]: value }));
  };

  const handleStatusApprove = async () => {
    try {
      const eSignStamp = {
        time: new Date(),
        userData: {
          name: userData?.name,
          userId: userData?._id,
          designation: selectedRole?.roleName,
          designationId: selectedRole?.roleId,
        },
      };

      let status = "";
      let statusHistory = data?.document?.statusHistory ?? [];
      let auditObj = {};
      let signFormRows = { ...data?.document?.signFormRows };
      if (decisionData?.decision === "Approved") {
        status = "Approved";

        auditObj = generateAuditObj({
          changedFields: [],
          documentId: data?._id,
          documentType: AuditDocumentTypes.Record,
          documentName: masterDocData?.name,
          action: AuditActionTypeConstant.Approve,
          actionMessage: `${userData?.name} - ${selectedRole?.roleName} has Approved ${masterDocData?.name}.`,
          // masterDocId: masterDocData?.masterDocId,
          masterDocId: "6a65a1639d306361d4a211d4",
          locationPath: `/${routeConstants.PRODUCTION}/coa/${id}`,
        });

        statusHistory.push({
          time: new Date(),
          status: decisionData?.decision,
          ...eSignStamp.userData,
        });
        signFormRows.approvedBy = eSignStamp;
      } else {
        status = "Modification";

        auditObj = generateAuditObj({
          changedFields: [],
          documentType: AuditDocumentTypes.Record,
          documentId: data?._id,
          documentName: masterDocData?.name,
          action: AuditActionTypeConstant.Review,
          actionMessage: `${userData?.name} - ${selectedRole?.roleName} has Reviewed ${masterDocData?.name}.`,
          // masterDocId: masterDocData?.masterDocId,
          masterDocId: "6a65a1639d306361d4a211d4",
          locationPath: `/${routeConstants.PRODUCTION}/coa/${id}`,
        });

        statusHistory.push({
          time: new Date(),
          status: decisionData?.decision,
          comment: decisionData?.comment,
          ...eSignStamp.userData,
        });
      }
      const reqObj = {
        bmrId: id,
        documentName: masterDocData?.name,
        status,
        document: {
          status,
          statusHistory,
          signFormRows,
        },
        auditObj,
      };

      const uri = url.UPDATE_SPECIFIC_BMR_HISTORY + data?._id;
      const result = await ApiServices.callServicePutWithBodyData(uri, reqObj);

      if (result?.meta?.success) {
        if (decisionData?.decision === "Approved") {
          let dispatchDepartmentUsers = await getUserDataByDesignation([
            {
              type: TypeConstants.TYPE_FIND_ALL_USERS_BY_DEPARTMENT,
              department: [DepartmentConstants.DISPATCH_DEPARTMENT],
            },
            {
              type: TypeConstants.TYPE_FIND_HEAD,
              department: [DepartmentConstants.DISPATCH_DEPARTMENT],
            },
          ]);

          const transformed = extractUserDetails(
            dispatchDepartmentUsers[TypeConstants.TYPE_FIND_HEAD],
          );
          const finishedProductMasterDocId = getMasterDoc(
            FormatConstants.FINISHED_REGISTER_PRODUCT.FINISHED_PRODUCT_REGISTER,
          );

          let finalRegisterObj = {
            masterDocId: finishedProductMasterDocId?.masterDocId,
            orgId: userData?.orgId,
            bmrId: data?.bmrId,
            productId: data?.document?.batchDetailsFormRows?.productId,
            productCodeId: data?.document?.batchDetailsFormRows?.variantId,
            receivedDate: new Date().toISOString(),
            quantity: data?.document?.yieldFormRows?.approvedQuantity,
            availableQuantity: data?.document?.yieldFormRows?.approvedQuantity,
            receiveBy: filterUserById(transformed),
            extraDetails: {
              receiver: transformed,
              dispatchDepartmentUsers:
                dispatchDepartmentUsers[
                  TypeConstants.TYPE_FIND_ALL_USERS_BY_DEPARTMENT
                ],
              dispatchDepartmentHeadUser:
                dispatchDepartmentUsers[TypeConstants.TYPE_FIND_HEAD],
            },
          };

          const uri = ADD_DATA;
          const tempResult = await ApiServices.callServicePostWithBodyData(
            uri,
            finalRegisterObj,
          );

          // update data
          if (tempResult?.meta?.success) {
            let notificationObj = {
              dataArray: [
                {
                  recipients: filterUserByIdAndDesignationId(transformed),
                  msg: "An final inspection has been done and it has been added to finished product register",
                  status: "Stock Updated.",
                  location: `finished-product-register/view-table/${data?.document?.batchDetailsFormRows?.productId}/${data?.document?.batchDetailsFormRows?.variantId}`,
                },
              ],
            };
            await sendNotification(notificationObj);
          }
        }
        getDataById();
        setModalType(false);
        submitData.current = {};
        setDecisionData({});
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    try {
      const {
        type,
        batchDetailsSubmit,
        conclusionFormSubmit,
        signFormSubmit,
        sterileNonSterileSubmit,
        yieldFormSubmit,
      } = submitData?.current || {};

      let status = "Prepared";
      let auditObj = {};
      let statusHistory = data?.document?.statusHistory ?? [];
      let result;

      const eSignStamp = {
        time: new Date(),
        userData: {
          name: userData?.name,
          userId: userData?._id,
          designation: selectedRole?.roleName,
          designationId: selectedRole?.roleId,
        },
      };

      let signFormRows = {
        ...(signFormSubmit ?? data?.document?.signFormRows),
        preparedBy: eSignStamp,
      };

      statusHistory.push({
        time: new Date(),
        status,
        ...eSignStamp.userData,
      });

      if (type === "Submit") {
        auditObj = generateAuditObj({
          changedFields: [],
          documentId: data?._id,
          documentType: AuditDocumentTypes.Record,
          documentName: masterDocData?.name,
          action: AuditActionTypeConstant.Prepare,
          actionMessage: `${userData?.name} - ${selectedRole?.roleName} has Prepared ${masterDocData?.name}.`,
          // masterDocId: masterDocData?.masterDocId,
          masterDocId: "6a65a1639d306361d4a211d4",
        });

        const reqObj = {
          // masterDocId: masterDocData?.masterDocId,
          masterDocId: "6a65a1639d306361d4a211d4",
          bmrId: id,
          document: {
            status,
            batchDetailsFormRows: batchDetailsSubmit,
            conclusionFormRows: conclusionFormSubmit,
            sterileNonSterileRows: sterileNonSterileSubmit?.rows,
            yieldFormRows: yieldFormSubmit,
            signFormRows,
            statusHistory,
          },
          auditObj,
        };
        result = await ApiServices.callServicePostWithBodyData(
          url.CREATE_PP,
          reqObj,
        );
        console.log("reqObjreqObjreqObjreqObj", reqObj);
        console.log("reqObjreqObjreqObjreqObj result", result);
      } else {
        const auditData = [
          {
            columns: findColumnsByDefaultName("Batch Detail Form"),
            oldRows: [data?.document?.batchDetailsFormRows ?? {}],
            newRows: [rows?.batchDetailsFormRows ?? {}],
            tableName: "Batch Detail Form",
            tableType: "Dynamic-Table",
          },
          {
            columns: findColumnsByDefaultName("Batch Sterile/NonSterile Table"),
            oldRows: data?.document?.sterileNonSterileRows ?? [],
            newRows: rows?.sterileNonSterileRows ?? [],
            tableName: "Batch Sterile/NonSterile Table",
            tableType: "Dynamic-Table",
          },
          {
            columns: findColumnsByDefaultName("Yield Calculation"),
            oldRows: [data?.document?.yieldFormRows ?? {}],
            newRows: [rows?.yieldFormRows ?? {}],
            tableName: "Yield Calculation",
            tableType: "Dynamic-Table",
          },
          {
            columns: findColumnsByDefaultName("Conclusion"),
            oldRows: [data?.document?.conclusionFormRows ?? {}],
            newRows: [rows?.conclusionFormRows ?? {}],
            tableName: "Yield Calculation",
            tableType: "Dynamic-Table",
          },
          {
            columns: findColumnsByDefaultName("Sign Table"),
            oldRows: [data?.document?.signFormRows ?? {}],
            newRows: [rows?.signFormRows ?? {}],
            tableName: "Sign Table",
            tableType: "Dynamic-Table",
          },
        ];
        auditObj = generateAuditObj({
          changedFields: getAllAuditChanges(auditData) ?? [],
          documentId: data?._id,
          documentType: AuditDocumentTypes.Record,
          documentName: masterDocData?.name,
          action: AuditActionTypeConstant.Modify,
          actionMessage: `${userData?.name} - ${selectedRole?.roleName} has Modified ${masterDocData?.name}.`,
          // masterDocId: masterDocData?.masterDocId,
          masterDocId: "6a65a1639d306361d4a211d4",
        });

        const reqObj = {
          // masterDocId: masterDocData?.masterDocId,
          masterDocId: "6a65a1639d306361d4a211d4",
          documentName: masterDocData?.name,
          bmrId: id,
          document: {
            status,
            batchDetailsFormRows: batchDetailsSubmit,
            conclusionFormRows: conclusionFormSubmit,
            sterileNonSterileRows: sterileNonSterileSubmit?.rows,
            yieldFormRows: yieldFormSubmit,
            signFormRows,
            statusHistory,
          },
          auditObj,
        };

        result = await ApiServices.callServicePutWithBodyData(
          `${url.UPDATE_SPECIFIC_BMR_HISTORY}${data?._id}`,
          reqObj,
        );
      }

      if (result?.meta?.success) {
        getDataById();

        submitData.current = {};
        setDecisionData({});
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  const handleDownload = async (data) => {
    showToast("File started to download", true);
    try {
      let reqObj = {
        formatId: data._id,
      };
      const auditObj = generateAuditObj({
        documentId: data?._id,
        changedFields: [],
        documentType: AuditDocumentTypes.Record,
        documentName: masterDocData?.name,
        action: AuditActionTypeConstant.Download,
        actionMessage: `${userData?.name}-${selectedRole?.roleName} has Downloaded ${masterDocData?.name}.`,
        masterDocId: masterDocData?._id,
        locationPath: `/${routeConstants.PRODUCTION}/coa/${data._id}`,
      });
      reqObj.auditObj = auditObj;
      let uri = url.DOWNLOAD_DOCUMENT;
      await downloadFormat(uri, reqObj, onChangeDownloadState);
    } catch (error) {
      console.warn("DOWNLOAD error", error);
    }
  };
  return (
    <MainCard
      // title={masterDocData?.name ?? ""}
      title={"Batch Release Checklist - Non Sterile"}
      secondary={
        <Stack direction={"row"} gap={2}>
          {data?.document?.status === "Prepared" && (
            <Button
              color="success"
              variant="contained"
              onClick={() => setModalType("Make Decision")}
            >
              Make Decision
            </Button>
          )}
          <IconButton
            onClick={() => handleDownload(data)}
            sx={{ backgroundColor: "rgba(97, 97, 97, 0.2)" }}
          >
            <Download />
          </IconButton>
          {data?._id && <DocumentAuditLogs recordId={data?._id} />}
        </Stack>
      }
    >
      <Stack gap={2}>
        {data?.document?.statusHistory?.at(-1)?.comment && (
          <Box
            sx={{
              bgcolor: "grey.100",
              border: "1px solid",
              borderColor: "grey.300",
              borderRadius: 2,
              p: 2,
              mt: 2,
              fontSize: 14,
              color: "text.primary",
            }}
          >
            <span style={{ fontWeight: "bold" }}>Comment:</span>{" "}
            {data.document.statusHistory.at(-1).comment}
          </Box>
        )}
        {/* Batch Details Form */}
        <CustomizeDynamicTable
          columns={
            data?.batchDetailsFormColunms ??
            findColumnsByDefaultName("Batch Detail Form") ??
            []
          }
          rows={rows?.batchDetailsFormRows ?? {}}
          isLoading={isLoading}
          config={{
            type: "form",
            addRow: { isVisible: true, isActive: true },
            isViewMode: ["Prepared", "Approved"]?.includes(
              data?.document?.status,
            ),
            onSubmit: {
              getSubmitHandler: (submitFn) => {
                submitHandlers.current.batchDetailsSubmit = submitFn;
              },
              isVisible: false,
            },
          }}
        />

        {/* Sterile / Non-Sterile */}
        <CustomizeDynamicTable
          columns={
            data?.sterileNonSterileColumns ??
            findColumnsByDefaultName("Batch Sterile/NonSterile Table") ??
            []
          }
          rows={rows?.sterileNonSterileRows ?? []}
          isLoading={isLoading}
          config={{
            type: "table",
            addRow: false,
            isViewMode: ["Prepared", "Approved"]?.includes(
              data?.document?.status,
            ),
            onSubmit: {
              checkValidation: true,
              getSubmitHandler: (submitFn) => {
                submitHandlers.current.sterileNonSterileSubmit = submitFn;
              },
              isVisible: false,
            },
          }}
        />

        {/* Yield Form */}
        <CustomizeDynamicTable
          columns={
            data?.yieldFormColumns ??
            findColumnsByDefaultName("Yield Calculation") ??
            []
          }
          rows={rows?.yieldFormRows ?? {}}
          isLoading={isLoading}
          config={{
            type: "form",
            isViewMode: ["Prepared", "Approved"]?.includes(
              data?.document?.status,
            ),
            addRow: { isVisible: true, isActive: true },
            onSubmit: {
              getSubmitHandler: (submitFn) => {
                submitHandlers.current.yieldFormSubmit = submitFn;
              },
              isVisible: false,
            },
          }}
        />

        {/* Conclusion Form */}
        <CustomizeDynamicTable
          columns={
            data?.conclusionFormColumns ??
            findColumnsByDefaultName("Conclusion") ??
            []
          }
          rows={rows?.conclusionFormRows ?? {}}
          isLoading={isLoading}
          config={{
            type: "form",
            addRow: { isVisible: true, isActive: true },
            isViewMode: ["Prepared", "Approved"]?.includes(
              data?.document?.status,
            ),
            onSubmit: {
              getSubmitHandler: (submitFn) => {
                submitHandlers.current.conclusionFormSubmit = submitFn;
              },
              isVisible: false,
            },
          }}
        />

        {/* Sign Form */}
        <CustomizeDynamicTable
          columns={
            data?.signFormColumns ??
            findColumnsByDefaultName("Sign Table") ??
            []
          }
          rows={rows?.signFormRows ?? {}}
          isLoading={isLoading}
          config={{
            type: "form",
            isViewMode: ["Prepared", "Approved"]?.includes(
              data?.document?.status,
            ),
            addRow: { isVisible: true, isActive: true },
            isViewMode: true,
            onSubmit: {
              getSubmitHandler: (submitFn) => {
                submitHandlers.current.signFormSubmit = submitFn;
              },
              isVisible: false,
            },
          }}
        />
      </Stack>

      <Stack>
        <Stack direction="row" justifyContent="flex-end" margin={2}>
          {(!data?.document?.status ||
            ["Modification"]?.includes(data?.document?.status)) && (
            <Button
              color="success"
              variant="contained"
              onClick={() =>
                handleMasterSubmit(
                  !data?.document?.status ? "Submit" : "Modification",
                )
              }
            >
              Submit
            </Button>
          )}
        </Stack>
      </Stack>
      {openEsign && (
        <ESign
          open={openEsign}
          setOpen={setOpenEsign}
          handleSubmit={handleSubmit}
        />
      )}

      {modalType === "Make Decision" ? (
        <CustomDialog open={modalType} onClose={() => setModalType(false)}>
          <DialogTitle>Make Decision</DialogTitle>
          <DialogContent>
            <Stack gap={2} margin={2}>
              <FormControl fullWidth>
                <InputLabel>Select Status</InputLabel>
                <Select
                  value={decisionData?.decision}
                  name="decision"
                  onChange={handleChange}
                >
                  {[
                    { name: "Approved", value: "Approved" },
                    { name: "Ask For Modification", value: "Modification" },
                  ]?.map((option, index) => {
                    return (
                      <MenuItem value={option?.value} key={index}>
                        {option?.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              {decisionData?.decision === "Modification" && (
                <FormControl fullWidth>
                  <TextField
                    multiline
                    label="Comment"
                    rows={5}
                    value={decisionData?.comment}
                    name="comment"
                    onChange={handleChange}
                  />
                </FormControl>
              )}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="contained"
              onClick={() => setModalType(false)}
            >
              Cancel
            </Button>
            <Button
              color="success"
              variant="contained"
              onClick={() => handleStatusApprove()}
            >
              Save
            </Button>
          </DialogActions>
        </CustomDialog>
      ) : null}
    </MainCard>
  );
};

export default withRouter(BatchCheckList);
